package com.daytimegaming.ourdailyfinances.presentation.util

import androidx.window.core.layout.WindowSizeClass
import androidx.window.core.layout.WindowSizeClass.Companion.HEIGHT_DP_EXPANDED_LOWER_BOUND
import androidx.window.core.layout.WindowSizeClass.Companion.HEIGHT_DP_MEDIUM_LOWER_BOUND
import androidx.window.core.layout.WindowSizeClass.Companion.WIDTH_DP_EXPANDED_LOWER_BOUND
import androidx.window.core.layout.WindowSizeClass.Companion.WIDTH_DP_MEDIUM_LOWER_BOUND

fun WindowSizeClass.isExpandedWidth() = isWidthAtLeastBreakpoint(WIDTH_DP_EXPANDED_LOWER_BOUND)
fun WindowSizeClass.isMediumWidth() = isWidthAtLeastBreakpoint(WIDTH_DP_MEDIUM_LOWER_BOUND) && !isExpandedWidth()
fun WindowSizeClass.isCompactWidth() = !isExpandedWidth() && !isMediumWidth()
fun WindowSizeClass.isExpandedHeight() = isHeightAtLeastBreakpoint(HEIGHT_DP_EXPANDED_LOWER_BOUND)
fun WindowSizeClass.isMediumHeight() = isHeightAtLeastBreakpoint(HEIGHT_DP_MEDIUM_LOWER_BOUND) && !isExpandedHeight()
fun WindowSizeClass.isCompactHeight() = !isExpandedHeight() && !isMediumHeight()

fun WindowSizeClass.isPhonePortrait() = isCompactWidth() && isExpandedHeight()
fun WindowSizeClass.isPhoneLandscape() = isExpandedWidth() && isCompactHeight()

fun WindowSizeClass.isTablet() = (isMediumWidth() || isExpandedWidth()) && (isMediumHeight() || isExpandedHeight())